/* eslint-disable max-len */
/* eslint-disable max-len */

export default {
  lang: 'French',
  homeScreen: {
    title: 'Remarquablement rare', // Product specific
    stayConnected: 'Rester Connecté(e):',
    comingSoon: 'À venir',
    messages: 'Messages',
  },
  loginScreen: {
    title: 'Programme de formation professionnelle en voyage et de promotion des ventes',
    welcome: {
      headerTop: 'Bienvenue au',
      headerBottom: 'spécialistes du Canada', // Product specific
    },
    sellingPoints: { // All selling points can be product specific
      0 : 'Apprendre, promouvoir et vendre en déplacement',
      1 : 'Formation multimédia sur tous les appareils',
      2 : 'Certificat d\'achèvement',
      3 : 'Présentations commerciales prêtes à l\'emploi',
      4 : 'Matériel promotionnel à fort impact',
      5 : 'Conseils d\'initiés et promotions',
      6 : 'Répertoire des produits en temps réel',
      7 : 'Nouvelles et mises à jour en temps opportun',
    },
    emailPrompt:
      'Veuillez entrer votre adresse email pour confirmer que vous êtes un professionnel du voyage.',
    tAndC: {
      agree: 'En continuant, vous acceptez notre',
      privacyPolicy: ' politique de confidentialité',
      and: ' et ',
      termsConditions: 'nos termes et conditions',
    },
    fields: {
      forgot: 'Veuillez fournir l\'adresse e-mail que vous avez utilisée lors de votre inscription à votre compte du Programme des spécialistes du Canada. Nous vous enverrons un email qui vous permettra de réinitialiser votre mot de passe.',
      password: 'Mot de passe',
      passwordConfirm: 'Confirmez votre mot de passe',
      agency: 'Agence',
      email: 'Email',
      firstName: 'Prénom',
      lastName: 'Nom',
      agencyName: "Nom de l'agence",
      stateProvince: 'État / Province',
      registrationCode: 'Code Promo (Optionnelle)',
      required: 'Obligatoire',
      invalidEmail: 'Adresse email invalide',
      opt: 'Reste en contact! Oui, j’aimerais opter pour les communications de Destination Canada qui me tiendront au courant des actualités, des événements, des incitations, des visites familiales et plus encore!',
    },
    noAgent: {
      noAgentButton: 'Je ne suis pas un agent',
      title: 'Merci de votre intérêt pour Canada ',
      messageWeb: 'Le contenu de ce site est exclusivement reservé aux professionnels du voyage.',
      messageMobile:
        "Une partie du contenu de cette application est exclusivement reservé aux professionnels du voyage, mais n'hésitez pas à naviguer un aperçu de ce que cette application peut offrir en appuyant sur « Continuer ». ",
      continue: 'Continuez',
      visitWebsite: 'Visiter le site web >',
    },
    newUser: 'Nouvel utilisateur',
    register: 'Enregistrer',
  },
  welcomeScreen: {
    title: 'Bienvenue au\nProgramme de formation et compagnon de ventes au spécialistes du Canada \n',
    helloUser: 'Salut',
    hello: 'Salut',
    fromAgency: 'de {agency}',
    notUser: 'Pas {name}?',
    introOnline:
      "Entraînez-vous immédiatement en ligne ou préchargez le contenu afin qu'il soit toujours disponible pour une utilisation hors ligne !",
    introOffline: 'Vous avez déjà la dernière version préchargée.',
    startTraining: 'Commencez par la formation',
    downloader: {
      preload: 'Précharger',
      stop: 'Arrêter',
      init: 'Initialiser...',
      lastUpdate: 'Dernière mise à jour:',
    },
  },
  trainingScreens: {
    unlock: 'Déverrouillez ce chapitre en terminant le chapitre {number} de la formation.',
    skip: 'Revenir >',
    review: 'Revoir >',
    viewAllTitle : '« Conseil de formation »',
    viewAll : '« Afin de passer à la page suivante, veuillez cliquer sur les icônes pour afficher le contenu supplémentaire. Des vidéos, des cartes et d\'autres informations utiles ont été fournies pour améliorer votre formation et vous assurer d\'atteindre le statut PRO.',
    start: 'Commencer',
    continue: 'Continuer',
    welcome: 'Bienvenue dans notre section Formation. Complétez des modules pour gagner des points et atteindre l’objectif ultime en devenant un.e spécialiste du Canada Or ! Suivez votre progression sur la barre située à droite de l’écran !',
    restart: 'Redémarrer',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Compléter',
    unlock: 'Déverrouiller ce chapitre en complétant le chapitre de formation {number}.',
    unlockSubtitle: 'Déverrouiller plus de chapitres en complétant les chapitres de formation.',
    allUnlocked: 'Vous avez déverrouillé tous les chapitres !',
    certificate: 'Certificat',
    courseComplete: 'Cours achevé !',
    chapterComplete: 'Chapter complete!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
    endReached: 'Vous avez atteint la fin',
    retainEnd:
      "Utilisez la barre supérieure pour naviguer ce chapitre ou appuyez sur le bouton retour pour revenir à la vue d'ensemble.",
    watchListenRead: 'Regarder, écouter et lire plus',
    trouble: 'Il semble que vous ayez des problèmes, veuillez relire le contenu de la ou des pages précédentes et réessayer.',
    confirm: 'Confirmer votre réponse',
    choose: 'Veuillez choisir une réponse',
    chapter: 'Chapitre',
    essential: 'Modules essentiels',
		essentialSub: 'Complétez ces modules pour obtenir votre statut spécialiste du Canada Bronze',
		specialization: 'Modules de spécialisation',
		specializationSub: 'Complétez ces modules pour obtenir le statut Silver spécialistes du Canada',
    status: 'Votre progression',
  },
  nav: {
    home: 'Accueil',
    train: 'Formation',
    retain: 'Découvrir',
    directory: 'Agenda',
    promote: 'Promouvoir',
    sell: 'Boîte à outils',
    info: 'Info',
    media: 'Média',
    favorites: 'Favoris',
    contact: 'Contact',
    reportCard: 'Bulletin',
    accountSettings: 'Paramètres du compte',
    messages: 'Message',
    search: 'Rechercher',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: 'Nos modules de formation',
    retain: 'Conserver',
    subapps: 'Mini modules de nos destinations partenaires',
    maintrainings: 'La Fondation',
    subtrainings: 'L\'Expérience',
  },
  pageDescriptions: {
    train:'Apprenez, participez et devenez expert',
    showroom : '',
    retain: 'Votre ressource incontournable pour conserver vos connaissances d\'expert et permettre vos efforts de vente. Utilisez cette zone pour répondre de manière experte à une question sur un produit ou même comme présentation de vente impromptue - à tout moment, n\'importe où et depuis n\'importe quel appareil.',
    promote: 'Démarrez la conversation avec vos clients et prospects.',
    sell: 'Répondez aux questions des clients et concluez la vente.',
    favorites: 'Découvrez votre contenu personnel favori',
    search: 'Rechercher dans tout le contenu',
    subapps: '',
    maintrainings: 'Terminez les modules de base pour obtenir votre diplôme.',
    subtrainings: 'Plongez dans les nombreuses expériences distinctives du Canada et obtenez le statut Argent',
  },
  general: {
    forgot: 'Mot de passe oublié?',
    register: 'S\'inscrire',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    back: 'Retour',
    close: 'Fermer',
    page: 'Page',
    search: 'Rechercher',
    logIn: 'Se Connecter',
    logOut: 'Se déconnecter',
    viewItem: 'Visualiser',
    showcase: 'Showcases',
    imageNotFound: 'Image non trouvée',
    noResultsFor: "Aucun résultat n'a été trouvé pour :",
    noFavorites: "Vous n'avez pas encore de favoris.",
    noMessages: "Vous n'avez pas encore reçu de messages !",
    resultsFor: 'Des résultats pour :',
    showAll: 'Afficher tout',
    connectionError: 'Erreur de connexion',
    alreadyExists: 'Existe déjà',
    pageNotFound: '404 Page non trouvée !',
    oops: 'Euh oh...',
    overview: "Retour à l'aperçu",
    complete: 'Cours achevé !',
    share: 'Partager',
    destinations: 'Mini formation de partenaire de la Canada',
    essentials: 'Les essentiels de la Canada',
    trainingLibrary: 'Bibliothèque de formation',
    message: '{count} Message',
    messagePlural: '{count} Messages',
    courseComplete: 'Cours achevé !',
    chapterComplete: 'Chapter complete!',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Mise en page',
    web: 'Site Web',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Faire tourner les cadrans pour faire correspondre à la réponse',
    fitb: 'Remplir les espaces vides',
    flip: 'Changer le numéro pour correspondre à la réponse',
    multipleChoice: 'Choisir la (les) bonne (s) réponse (s)',
    slider: "Choisir la bonne réponse à l'aide du curseur",
    map: 'Répondre à la question en appuyant sur le bon emplacement sur la carte',
    dropdown: 'Choisir...',
    true: 'Vrai',
    false: 'Faux',
  },
  cookies: {
    consent: 'ACCEPTER',
    optout: 'Se désengager',
    settings: 'Paramètres de confidentialité ',
    message:
      'Vous ne nous avez rien communiqué à propos de vos préférences en matière de confidentialité des données !',
    disabled: "Il semble que vous ayez désactivé l'utilisation des cookies.",
    use:
      "Le {Nom de l’app} exige l'utilisation de cookies pour vous offrir la meilleure expérience.",
    details: 'À quoi servent les cookies ?',
    enable: 'Voir comment activer vos cookies {ici}.',
    here: 'ici',
  },
  notLoggedIn: {
    super: "Vous n'êtes pas connecté",
    title: 'Vous devez être connecté pour visualiser ce contenu',
    guest: 'L’invité',
  },
  demo: {
    message: 'Ce site Web est une démonstration du produit final.',
    consent: '',
  },
  share: {
    header: '',
    download: 'download',
  },
  sharing: {
    copyURL : 'Copier le lien',
    copied : 'Copié',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: "Il semble que vous essayez d'accéder à {appName} à partir d'un appareil mobile.",
    body:
      "Pour télécharger ce programme, visitez tout simplement l’app store et recherchez {appName} ou cliquez sur l'un des boutons ci-dessous",
    benefits: {
      header: 'Cela vous fournira :',
      1: 'La portabilité',
      2: 'Pas besoin de WiFi, entraînez-vous quand et où il vous convient',
      3: 'Des outils et des ressources de vente à votre portée',
    },
  },
	newTrainingFlow: {
		tip: 'Vous obtenez votre statut en complétant les modules de chaque niveau.  Rêvez en grand et obtenez le statut Gold CA spécialistes du Canada by completing aen complétant tous les modules !',
		essentialModules: 'Modules essentiels',
		finishBronze: 'Complétez ces modules pour obtenir votre statut spécialistes du Canada Bronze',
		specializationModules: 'Modules de spécialisation',
		finishSilver: 'Complétez ces modules pour obtenir le statut Silver spécialistes du Canada',
		partnerModules: 'Modules partenaires',
		finishGold: 'Complétez ces modules pour obtenir votre statut Gold spécialistes du Canada',
		currentStatus: 'Situation actuelle',
		pointsToLevel: '{pointsToLevel} {points} ',
		reachedRanking: 'jusqu’à ce que vous ayez atteint le {rank} classement !',
		outOf: 'de {points}  XP sur les',
		pointsToRank:  '{pointsToLevel} XP devrait se classer :  ({rank})',
	},
  points: {
    completed: '{completed} / {total} complété',
  }
};
